import { firestoreAction } from 'vuexfire'

import { firestore } from '@/plugins/firebase'
import pkg from '@/../package.json'

const state = {
  authFirstCheck: true,
  currentUser: null,
  engagement: null,
  integrations: null
}

const getters = {
  currentUid (state) {
    return state.currentUser ? state.currentUser.id : null
  },
  currentUser (state) {
    return state.currentUser
  },
  preferences (state) {
    return state.currentUser ? state.currentUser.preferences || {} : {}
  },
  profile (state) {
    return state.currentUser ? state.currentUser.profile || {} : {}
  },
  currentOrganization (state) {
    return state.currentUser ? state.currentUser.currentOrganization : null
  },

  // User role in current organization
  getUserRole: (state, getters) => (uid) => {
    let currentOrg = getters.currentOrganization
    return currentOrg && currentOrg.users ? currentOrg.users[uid] : null
  },
  getCurrentUserRole (state, getters) {
    return getters.getUserRole(getters.currentUid)
  },
  isOwner (state, getters) {
    return getters.getCurrentUserRole === 'owner'
  }
}

const mutations = {
  setCurrentUser (state, user) {
    if (user) {
      state.currentUser = {
        id: user.uid,
        displayName: user.displayName,
        email: user.email,
        photoURL: user.photoURL
      }
    } else {
      state.currentUser = null
    }
  }
}

const actions = {
  bind: firestoreAction(({ bindFirestoreRef }, uid) => {
    return bindFirestoreRef('currentUser',
      firestore
        .collection('users')
        .doc(uid)
    )
  }),
  bindEngagement: firestoreAction(async ({ bindFirestoreRef, state, dispatch }) => {
    let ret = await bindFirestoreRef('engagement',
      firestore
        .collection('engagement')
        .doc(state.currentUser.id)
    )

    let isNewerVersion = false

    if (state.engagement && state.engagement.appVersion) {
      const userV = state.engagement.appVersion.split('.').map(x => parseInt(x))
      const appV = pkg.version.split('.').map(x => parseInt(x))

      for (let i in appV) {
        if (appV[i] > userV[i]) { isNewerVersion = true }
      }

      if (isNewerVersion) {
        // show whats new
      }
    } else {
      isNewerVersion = true
    }

    if (isNewerVersion) {
      dispatch('setEngagement', { what: 'appVersion', value: pkg.version })
    }

    return ret
  }),
  setEngagement ({ state }, { what, value }) {
    const data = {}
    data[what] = value

    let ref = firestore
      .collection('engagement')
      .doc(state.currentUser.id)

    if (state.engagement) {
      ref = ref.update(data)
    } else {
      ref = ref.set(data)
    }

    return ref
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
